module.exports = __webpack_public_path__ + "img/ctrl-p-stub-up-1.07c82926.svg";